import type { MarketCode } from '@/lib/market'

const runtime: AureRuntimeConfig = typeof window === 'undefined' ? {} : (window.__AURE__ ?? {})
const apiUrl = (runtime.apiUrl || import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '')
const marketCode = (runtime.market || import.meta.env.VITE_MARKET || 'cl').toLowerCase()
const metaPixelId = (runtime.metaPixelId || import.meta.env.VITE_META_PIXEL_ID || '').trim()
const clarityId = (runtime.clarityId || import.meta.env.VITE_CLARITY_ID || '').trim()

function toMarket(code: string): MarketCode {
  return code === 'br' || code === 'us' ? code : 'cl'
}

export const config = {
  apiOrigin: apiUrl.replace(/\/api$/, ''),
  market: toMarket(marketCode),
  metaPixelId: metaPixelId || null,
  clarityId: clarityId || null,
}
